import React from 'react';
import { NewPasswordForm } from '@app/components/auth/NewPasswordForm/NewPasswordForm';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { useSearchParams } from 'react-router-dom';

const NewPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <>
      <PageTitle>{t('common.newPassword')}</PageTitle>
      <NewPasswordForm oob={searchParams.get('oobCode')} />
    </>
  );
};

export default NewPasswordPage;
